import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

declare global {
  interface Date {
    toFormattedString(): string;
    toAgoString(): string;
  }
}

Date.prototype.toFormattedString = function () {
  try {
    if (isNaN(this.getTime())) {
      throw new Error('Invalid date');
    }
    const day = this.getDate().toString().padStart(2, '0');
    const month = (this.getMonth() + 1).toString().padStart(2, '0');
    const year = this.getFullYear();
    return `${day}.${month}.${year}`;
  } catch (error) {
    console.error('Date.toFormattedString:', error);
    return 'Invalid date';
  }
};

Date.prototype.toAgoString = function () {
  try {
    if (isNaN(this.getTime())) {
      throw new Error('Invalid date');
    }
    return dayjs().to(this);
  } catch (error) {
    console.error('Date.toFormattedStringAgo:', error);
    return 'Invalid date';
  }
};

export { };
